import { connect } from "react-redux";
import { Dispatch } from "redux";
import IAppState from "../../redux/types/IAppState";
import MyAccountPage from "./MyAccountPage";
import { getUserCRMValuesThunk } from "../../redux/thunks/AccountThunks";

export default connect(
    (state: IAppState) => ({
        isCRMIntegrationEnabled: state.membersPortal.isCRMIntegrationEnabled,
        powerPortalURL: state.membersPortal.powerPortalURL,
        currentUserGuid: state.account.currentUserGuid,
        currentUserNameNumber: state.account.currentUserNameNumber
    }),
    (dispatch: Dispatch) => ({
        getUserCRMValues: () => dispatch<any>(getUserCRMValuesThunk()),

    })
)(MyAccountPage);